<template>
    <div class="body-banner">
        <div style="display: flex;justify-content:space-between;">
            <el-button @click="downloadBrowser" type="mini">点击下载 使用教程</el-button>
            <el-popover
                placement="top-start"
                title="提示"
                width="200"
                trigger="hover"
                content="邀请一个新用户可以增加500个关键词数量">
                <span style="color: #358eec;cursor: pointer;" slot="reference" @click="copy">复制邀请链接</span>
            </el-popover>

        </div>
        <div class="title1" style="font-size: 32px;">麦迦数据功能介绍</div>
        <div class="title1">关键词监控</div>
        <div class="title2">监控亚马逊商品的搜索关键词排名</div>
        <div class="title2">显示对应的排名曲线图</div>
        <div class="title1">评价监听</div>
        <div class="title2">检测链接是否掉评</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [],
            registrationurl: "",
            query: {
                page: 1,
                limit: 10
            }
        };
    },
    methods: {
        statistics() {
            // api.statistics().then(res => {
            //     if (res.code === 0) {
            //         // 提交成功, 关闭窗口, 刷新列表
            //         this.list = res.data;
            //     }
            // });
        },
        downloadBrowser() {
            var a = document.createElement("a");
            a.setAttribute("href", "/export/麦迦数据使用教程.pdf");
            document.body.appendChild(a);
            a.click();
        },
        copy() {
            var oInput = document.createElement("input");
            oInput.value = this.registrationurl;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            oInput.className = "oInput";
            oInput.style.display = "none";
            this.$message({
                message: "复制成功",
                type: "success"
            });
        }
    },
    mounted() {
        this.statistics();
        this.registrationurl =
            process.env.VUE_LOCAL_DOMAIN+"#/agent?spread_uid=" +
            this.$store.state.admin.adminId;
    }
};
</script>

<style lang="scss" scoped>
.body-banner {
    margin: 10px;
}
.title {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 22px;
    font-weight: bolder;
    color: #3e4754;
}
.title1 {
    font-size: 22px;
    font-weight: 700;
    color: #1d2c42;
    margin-top: 20px;
    margin-bottom: 10px;
}
.videoClick {
    display: inline-block;
    margin: 20px;
    color: #4d5156;
}
.videoClick:hover {
    cursor: pointer;
    color: #000;
    text-decoration: underline;
}
.registration {
    color: rgba(0, 0, 0, 0.7);
    margin: 20px;
}
.registrationurl_i:hover {
    cursor: pointer;
    text-decoration: underline;
}
.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both;
}

.box-card {
    width: 100%;
}
.i-icon {
    font-size: 40px;
}
.chcek_group:hover {
    cursor: pointer;
    text-decoration: underline;
}
.panel-group {
    // margin-top: 18px;

    .card-panel-col {
        margin-bottom: 32px;
    }

    .card-panel {
        display: flex;
        justify-content: space-between;
        height: 90px;
        cursor: pointer;
        font-size: 12px;
        position: relative;
        overflow: hidden;
        color: #666;
        background: #fff;
        box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
        border-color: rgba(0, 0, 0, 0.05);

        &:hover {
            .card-panel-icon-wrapper {
                color: #fff;
            }

            .icon-people {
                background: #40c9c6;
            }

            .icon-message {
                background: #36a3f7;
            }

            .icon-money {
                background: #f4516c;
            }

            .icon-shopping {
                background: #8f9796;
            }
        }

        .icon-people {
            color: #40c9c6;
        }

        .icon-message {
            color: #36a3f7;
        }

        .icon-money {
            color: #f4516c;
        }

        .icon-shopping {
            color: #8f9796;
        }

        .card-panel-icon-wrapper {
            float: left;
            margin: 10px 0 10px 10px;
            padding: 16px;
            transition: all 0.38s ease-out;
            border-radius: 6px;
        }

        .card-panel-icon {
            float: left;
            font-size: 48px;
        }

        .card-panel-description {
            float: right;
            font-weight: bold;
            margin: 15px;
            margin-left: 0px;

            .card-panel-text {
                line-height: 18px;
                color: rgba(0, 0, 0, 0.45);
                font-size: 17px;
                margin-bottom: 12px;
            }
            .card-panel-text1 {
                line-height: 18px;
                color: rgba(0, 0, 0, 0.45);
                text-align: right;
                font-size: 16px;
                margin-bottom: 12px;
            }

            .card-panel-num {
                font-size: 20px;
            }
        }
    }
}

@media (max-width: 550px) {
    .card-panel-description {
        display: none;
    }
    .card-panel-icon-wrapper {
        float: none !important;
        width: 100%;
        height: 100%;
        margin: 0 !important;
        .svg-icon {
            display: block;
            margin: 14px auto !important;
            float: none !important;
        }
    }
}
.ms-doc {
    width: 100%;
    max-width: 980px;
    font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
    color: #2d2f33;
}
.ms-doc h3 {
    padding: 9px 10px 10px;
    margin: 0;
    font-size: 14px;
    line-height: 17px;
    background-color: #f5f5f5;
    border: 1px solid #d8d8d8;
    border-bottom: 0;
    border-radius: 3px 3px 0 0;
}
.ms-doc article {
    padding: 45px;
    word-wrap: break-word;
    background-color: #fff;
    border: 1px solid #ddd;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
}
.ms-doc article h1 {
    font-size: 32px;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
}
.ms-doc article h2 {
    margin: 24px 0 16px;
    font-weight: 600;
    line-height: 1.25;
    padding-bottom: 7px;
    font-size: 24px;
    border-bottom: 1px solid #eee;
}
.ms-doc article p {
    margin-bottom: 15px;
    line-height: 1.5;
}
.ms-doc article .el-checkbox {
    margin-bottom: 5px;
}
</style>
